import { PaletteMode } from '@mui/material';
import styled from 'styled-components';
import { ModalViews } from '../../../constants';
import { Icon, Typography } from '../../../stories/atoms';
import { RowFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { Color } from '../../../theme';

export const StyledImage = styled.img<{ size: 'small' | 'medium' | 'large' }>`
  max-height: ${({ theme, size }) =>
    size === 'large' ? theme.spacing(80) : size === 'small' ? theme.spacing(10) : theme.spacing(20)};
  max-width: fit-content;
`;

export const StyledMultipleCardWrapper = styled(RowFlexContainer)`
  border-bottom: 1px solid
    ${({ theme: { color, palette } }) => (palette.mode === 'dark' ? color.borderGrayDark : color.borderGray)};
`;

export const StyledTypography = styled(Typography)`
  color: ${({ theme: { color, palette } }) =>
    palette.mode === 'dark' ? color.secondaryDarkTextGray : color.textGray};
`;

const getActionIconColor = (colors: Color, mode: PaletteMode, modalView: ModalViews) => {
  if (mode === 'light') {
    return modalView === ModalViews.INITIAL
      ? colors.red
      : modalView === ModalViews.SUCCESS
      ? colors.validationGreen
      : colors.warningDark;
  } else {
    return modalView === ModalViews.INITIAL
      ? colors.error
      : modalView === ModalViews.SUCCESS
      ? colors.success
      : colors.warning;
  }
};

export const StyledActionIcon = styled(Icon)<{ modalView: ModalViews }>`
  color: ${({ theme: { color, palette }, modalView }) => getActionIconColor(color, palette.mode, modalView)};
`;
